import { UseAxiosResult } from 'axios-hooks'
import { useAxiosClient } from './configs/axios-setup'

export interface IRequestError {
  status: number
  text: string
}

export const useGetAdmApiSeries = (): UseAxiosResult => {
  const [{ data, loading, error }, doFetch] = useAxiosClient(
    {
      url: '/PressureTapImport/series',
      method: 'GET'
    },
    { manual: true, autoCancel: false, useCache: false }
  )

  const refetch = () => {
    return doFetch({
      url: '/PressureTapImport/series'
    })
  }

  return [
    { data, loading, error },
    refetch,
    () => {
      return
    }
  ]
}

export const useGetAdmApiBaseConfigs = (): UseAxiosResult => {
  const [{ data, loading, error }, doFetch] = useAxiosClient(
    {
      method: 'GET'
    },
    { manual: true, autoCancel: false, useCache: false }
  )

  const refetch = seriesId => {
    return doFetch({
      url: `/PressureTapImport/series/${seriesId}/baseconfigs`
    })
  }

  return [
    { data, loading, error },
    refetch,
    () => {
      return
    }
  ]
}

export const useGetAdmApiConfigDetail = (): UseAxiosResult => {
  const [{ data, loading, error }, doFetch] = useAxiosClient(
    {
      method: 'GET'
    },
    { manual: true, autoCancel: false, useCache: false }
  )

  const refetch = configId => {
    return doFetch({
      url: `/PressureTapImport/baseconfigs/${configId}`
    })
  }

  return [
    { data, loading, error },
    refetch,
    () => {
      return
    }
  ]
}

export const useImportPressureTapConfig = (): UseAxiosResult => {
  const [{ data, loading, error }, doFetch] = useAxiosClient(
    {
      method: 'POST'
    },
    { manual: true, autoCancel: false, useCache: false }
  )

  const refetch = ({ seriesId, configId, body }: any) => {
    return doFetch({
      url: `/PressureTapImport/series/${seriesId}/baseconfigs/${configId}/import`,
      data: body
    })
  }

  return [
    { data, loading, error },
    refetch,
    () => {
      return
    }
  ]
}

export const useDeletePtapLocationSet = (): UseAxiosResult => {
  const [{ data, loading, error }, doFetch] = useAxiosClient(
    {
      method: 'DELETE'
    },
    { manual: true, autoCancel: false, useCache: false }
  )

  const refetch = ({ id }: any) => {
    return doFetch({
      url: `/PressureTapImport/${id}`
    })
  }

  return [
    { data, loading, error },
    refetch,
    () => {
      return
    }
  ]
}

export const useUploadPressureTapCsv = (): UseAxiosResult => {
  const [{ data, loading, error }, doFetch] = useAxiosClient(
    {
      method: 'POST'
    },
    { manual: true, autoCancel: false, useCache: false }
  )

  const refetch = (body: any) => {
    return doFetch({
      url: '/PressureTapImport/upload',
      data: body
    })
  }

  return [
    { data, loading, error },
    refetch,
    () => {
      return
    }
  ]
}
